const DEFAULT_LOCAL_API_ROOT = 'http://localhost:3000';

function normalizeBase(url?: string | null) {
  return url?.replace(/\/$/, '') || undefined;
}

function getBrowserLocation() {
  if (typeof window === 'undefined' || !window.location) {
    return null;
  }

  return window.location;
}

function isLocalHostname(hostname: string) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function resolveApiRoot(configuredBase?: string | null) {
  const normalizedConfigured = normalizeBase(configuredBase);
  const browserLocation = getBrowserLocation();

  if (!browserLocation) {
    return normalizedConfigured ?? DEFAULT_LOCAL_API_ROOT;
  }

  if (!isLocalHostname(browserLocation.hostname)) {
    return normalizeBase(browserLocation.origin) ?? normalizedConfigured ?? DEFAULT_LOCAL_API_ROOT;
  }

  return normalizedConfigured ?? DEFAULT_LOCAL_API_ROOT;
}

export function resolveApiBase(configuredBase?: string | null) {
  return `${resolveApiRoot(configuredBase)}/api`;
}
